import Main from './SupplierInvite'

export default { Main }
